import request from "@/utils/request";

// 算力资源管理 - 列表
export function goodsPage(query) {
  return request({
    url: '/blade-system/goods/list',
    method: 'get',
    params: query
  })
}

// 算力资源管理 - 新增
export function goodsSave(data) {
  return request({
    url: '/blade-system/goods/save',
    method: 'post',
    data: data
  })
}

// 算力资源管理 -编辑
export function goodsUpdate(data) {
  return request({
    url: '/blade-system/goods/update',
    method: 'post',
    data: data
  })
}

// 算力资源管理 - 删除
export function goodsRemove(ids) {
  return request({
      url: "/blade-system/goods/remove",
      method: "post",
      params: { ids },
  });
}
// 算力资源管理 - 导入
export function goodsImport(data) {
  return request({
    url: '/blade-system/goods/import-goods',
    method: 'post',
    data: data
  })
}

// 算力资源管理 - 批量上下架
export function goodsBatchStatus(data) {
  return request({
    url: '/blade-system/goods/batch-status',
    method: 'post',
    params: data
  })
}

// 新闻公告管理 - 列表
export function newsPage(query) {
  return request({
    url: '/blade-system/news/list',
    method: 'get',
    params: query
  })
}
// 新闻公告管理 - 新增
export function newsSave(data) {
  return request({
    url: '/blade-system/news/save',
    method: 'post',
    data: data
  })
}
// 新闻公告管理 -编辑
export function newsUpdate(data) {
  return request({
    url: '/blade-system/news/update',
    method: 'post',
    data: data
  })
}

// 新闻公告管理 -删除
export function newsRemove(ids) {
  return request({
    url: '/blade-system/news/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}

//重要公告管理 - 列表
export function announcementPage(query) {
  return request({
    url: '/blade-system/announcement/list',
    method: 'get',
    params: query
  })
}
//重要公告管理 - 新增
export function announcementSave(data) {
  return request({
    url: '/blade-system/announcement/save',
    method: 'post',
    data: data
  })
}
//重要公告管理 -编辑
export function announcementUpdate(data) {
  return request({
    url: '/blade-system/announcement/update',
    method: 'post',
    data: data
  })
}
//重要公告管理 -删除
export function announcementRemove(ids) {
  return request({
    url: '/blade-system/announcement/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}

// 公共服务平台 - 列表
export function infoServicePage(query) {
  return request({
    url: '/blade-system/info/list',
    method: 'get',
    params: query
  })
}

// 公共服务平台 - 新增/编辑
export function infoServiceSubmit(data) {
  return request({
    url: '/blade-system/info/submit',
    method: 'post',
    data: data
  })
}

// 地方算力平台 - banner图 - 列表
export function areaPlatformList(query) {
  return request({
    url: '/blade-system/areaPlatform/list',
    method: 'get',
    params: query
  })
}

// 地方算力平台 - banner图 - 新增/编辑
export function areaPlatformSubmit(data) {
  return request({
    url: '/blade-system/areaPlatform/submit',
    method: 'post',
    data: data
  })
}

// 地方算力平台 - 核心资源 - 列表
export function areaCoreResourceList(query) {
  return request({
    url: '/blade-system/areaCoreResource/list',
    method: 'get',
    params: query
  })
}
//地方算力平台 - 核心资源 - 新增
export function areaCoreResourceSave(data) {
  return request({
    url: '/blade-system/areaCoreResource/save',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 核心资源 - 编辑
export function areaCoreResourceUpdate(data) {
  return request({
    url: '/blade-system/areaCoreResource/update',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 核心资源 - 删除
export function areaCoreResourceRemove(ids) {
  return request({
    url: '/blade-system/areaCoreResource/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}

// 地方算力平台 - 特色服务 - 列表
export function areaFeaturedServiceList(query) {
  return request({
    url: '/blade-system/areaFeaturedService/list',
    method: 'get',
    params: query
  })
}
//地方算力平台 - 特色服务 - 新增
export function areaFeaturedServiceSave(data) {
  return request({
    url: '/blade-system/areaFeaturedService/save',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 特色服务 - 编辑
export function areaFeaturedServiceUpdate(data) {
  return request({
    url: '/blade-system/areaFeaturedService/update',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 特色服务 - 删除
export function areaFeaturedServiceRemove(ids) {
  return request({
    url: '/blade-system/areaFeaturedService/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}

// 地方算力平台 - 政策支持 - 列表
export function areaPolicySupportList(query) {
  return request({
    url: '/blade-system/areaPolicySupport/list',
    method: 'get',
    params: query
  })
}
//地方算力平台 - 政策支持 - 新增
export function areaPolicySupportSave(data) {
  return request({
    url: '/blade-system/areaPolicySupport/save',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 政策支持 - 编辑
export function areaPolicySupportUpdate(data) {
  return request({
    url: '/blade-system/areaPolicySupport/update',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 政策支持 - 删除
export function areaPolicySupportRemove(ids) {
  return request({
    url: '/blade-system/areaPolicySupport/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}

// 地方算力平台 - 应用案例 - 列表
export function areaApplicationCaseList(query) {
  return request({
    url: '/blade-system/areaApplicationCase/list',
    method: 'get',
    params: query
  })
}
//地方算力平台 - 应用案例 - 新增
export function areaApplicationCaseSave(data) {
  return request({
    url: '/blade-system/areaApplicationCase/save',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 应用案例 - 编辑
export function areaApplicationCaseUpdate(data) {
  return request({
    url: '/blade-system/areaApplicationCase/update',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 应用案例 - 删除
export function areaApplicationCaseRemove(ids) {
  return request({
    url: '/blade-system/areaApplicationCase/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}

// 地方算力平台 - 新闻动态 - 列表 - 江苏
export function areaNewsList(query) {
  return request({
    url: '/blade-system/areaNews/list',
    method: 'get',
    params: query
  })
}
//地方算力平台 - 新闻动态 - 新增 - 江苏
export function areaNewsSave(data) {
  return request({
    url: '/blade-system/areaNews/save',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 新闻动态 - 编辑 - 江苏
export function areaNewsUpdate(data) {
  return request({
    url: '/blade-system/areaNews/update',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 新闻动态 - 删除 - 江苏
export function areaNewsRemove(ids) {
  return request({
    url: '/blade-system/areaNews/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}
// 地方算力平台 - 新闻动态 - 详情 - 江苏
export function areaNewsDetail(query) {
  return request({
    url: '/blade-system/areaNews/detail',
    method: 'get',
    params: query
  })
}

// 地方算力平台 - 政策指南 - 列表 - 江苏
export function areaPolicyList(query) {
  return request({
    url: '/blade-system/areaPolicy/list',
    method: 'get',
    params: query
  })
}
//地方算力平台 - 政策指南 - 新增 - 江苏
export function areaPolicySave(data) {
  return request({
    url: '/blade-system/areaPolicy/save',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 政策指南 - 编辑 - 江苏
export function areaPolicyUpdate(data) {
  return request({
    url: '/blade-system/areaPolicy/update',
    method: 'post',
    data: data
  })
}
//地方算力平台 - 政策指南 - 删除 - 江苏
export function areaPolicyRemove(ids) {
  return request({
    url: '/blade-system/areaPolicy/remove',
    method: 'post',
    params: {
      ids,
    },
  })
}


/**
 * 文件流返回
 * @param url 接口地址
 * @param params 接口参数
 */
export const exportBlob = (url, params) => {
  return request({
    url: url,
    params: params,
    method: 'get',
    responseType: 'blob',
  });
};

// 上传文件
export const uploadFile = (data) => {
  return request({
    url: '/blade-resource/oss/endpoint/put-file',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
